import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCoinRand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCoinRand"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM8.5 11.25H7V12.75H8.5V16.5H10V10.3516L14.0986 16.5H15.5V12.75H17V11.25H15.5V7.5H14V13.6475L9.90137 7.5H8.5V11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCoinRand;
